import { Component, HostListener } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';
import * as _ from 'lodash';

@Component({
  selector: 'tooltip-component',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  public tooltipY: number;
  public tooltipX: number;
  public rightAligned: boolean;
  public hitAreaRect: any;

  constructor(public sharedService: SharedService) {
    this.rightAligned = false;
  }

  ngOnInit() {
    this.sharedService.getMessagesBus().subscribe((response: any) => {
      if (response.type === 'SHOW_TOOLTIP') {
        this.updateTooltipSettings();
      }
    });
  }

  updateTooltipSettings() {
    const tooltip: any = document.getElementById('tooltip');
    this.hitAreaRect = this.sharedService.tooltipData.element.getBoundingClientRect();
    this.tooltipY = _.cloneDeep(this.sharedService.tooltipData.element.offsetHeight);

    if (tooltip && tooltip.hitAreaRect && !this.sharedService.tooltipData.triangleAtTop) {
      this.tooltipY -= this.hitAreaRect.height;
    }

    if (
      this.sharedService.tooltipData.element.parentElement &&
      this.sharedService.tooltipData.element.parentElement.classList &&
      this.sharedService.tooltipData.element.parentElement.classList.length
    ) {
      this.rightAligned = this.sharedService.tooltipData.element.parentElement.classList.contains('rightAlignedCell');
    }

    setTimeout(() => {
      if (this.sharedService.tooltipData.centered) {
        if (this.sharedService.tooltipData.parentWidth > tooltip.offsetWidth) {
          this.sharedService.tooltipData.x = (this.sharedService.tooltipData.parentWidth - tooltip.offsetWidth) / 2;
        }
        this.sharedService.tooltipData.triangleX = tooltip.offsetWidth / 2 - 6;
      } else {
        this.tooltipX = tooltip.offsetWidth;
      }
    });
  }

  onMouseMove($event: Event) {
    const tooltip: any = document.getElementById('tooltip');
    let top: boolean;
    let right: boolean;
    let bottom: boolean;
    let left: boolean;
    if (this.sharedService.tooltipData.visible && this.hitAreaRect && tooltip) {
      left = this.sharedService.getMouseCoords($event, 'x') >= this.hitAreaRect.left;
      right = this.sharedService.tooltipData.editable
        ? this.sharedService.getMouseCoords($event, 'x') <= this.hitAreaRect.right + tooltip.offsetWidth
        : this.sharedService.getMouseCoords($event, 'x') <= this.hitAreaRect.right;
      top = this.sharedService.getMouseCoords($event, 'y') >= this.hitAreaRect.top;
      bottom = this.sharedService.tooltipData.editable
        ? this.sharedService.getMouseCoords($event, 'y') <= this.hitAreaRect.bottom + tooltip.offsetHeight
        : this.sharedService.getMouseCoords($event, 'y') <= this.hitAreaRect.bottom;
      if (!(top && right && bottom && left)) {
        this.sharedService.hideTooltip();
      }
    }
  }

  @HostListener('document:mousemove', ['$event'])
  mouseMoveListener($event: Event) {
    this.onMouseMove($event);
  }
}
